import { Route } from '@/app/router'

const Companies = () => import('./index.vue')

const CompaniesMeta = {
	sort: 2,
	displayInSidebar: true,
	displayName: 'company',
	icon: 'fal building',
	activeIcon: 'fas building'
}

const CompaniesProps = ['page', 'perPage']

export default new Route('/companies', Companies).as('Dashboard:Companies').meta(CompaniesMeta).props(CompaniesProps).permissions(['VIEW_COMPANIES'])
